import React from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { Textarea } from "./ui/textarea";
import { Checkbox } from "./ui/checkbox";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const ComprehensiveFormV2 = ({ info = {}, updateField }) => {

  // const countFilled = (keys) => {
  //   if (!info) return 0;
  //   return keys.reduce((acc, key) => {
  //     const v = info[key];
  //     if (v === null || v === undefined) return acc;
  //     if (typeof v === "boolean") return v ? acc + 1 : acc;
  //     if (typeof v === "string") return v.trim() === "" ? acc : acc + 1;
  //     return acc + 1;
  //   }, 0);
  // };

  console.log("ComprehensiveFormV2 info:", info);
  console.log("ComprehensiveFormV2 updateField:", updateField);

// HELPER: count filled fields  

const countFilled = (keys) => {
  if (!info) return 0;
  
  return keys.reduce((acc, key) => {
    const v = info[key];
    
    // Not filled: null or undefined
    if (v === null || v === undefined) return acc;
    
    // Boolean: only count if true (checkbox checked)
    if (typeof v === "boolean") return v ? acc + 1 : acc;
    
    // String: only count if not empty AND not a placeholder
    if (typeof v === "string") {
      const trimmed = v.trim();
      
      // Empty string = not filled
      if (trimmed === "") return acc;
      
      // Check if it's a placeholder value (not really filled)
      const placeholders = ["dd-mm-yyyy", "DD-MM-YYYY", "select", "Select", "N/A", "n/a"];
      if (placeholders.includes(trimmed)) return acc;
      
      // For date fields: check if it can be displayed in the form
      const isDateField = key.includes("date") || key.includes("Date") || key === "date_of_birth";
      if (isDateField) {
        // Valid date formats that the form can display
        const validDatePattern = /^\d{2}-\d{2}-\d{4}$|^\d{4}-\d{2}-\d{2}$/;
        
        // If it doesn't match valid format, the form can't display it = not filled
        if (!validDatePattern.test(trimmed)) return acc;
      }
      
      // Has valid value = filled
      return acc + 1;
    }
    
    // Any other type with value = filled
    return acc + 1;
  }, 0);
}

  // ------------------------------------------------------------
  // DATE NORMALIZER — NEVER CHANGES ACTUAL BACKEND DATA
  // ------------------------------------------------------------
  const normalizeDateValue = (raw) => {
    if (!raw) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    const iso = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    if (iso) return iso[1];
    const ymd = raw.match(/^(\d{4})[./-](\d{1,2})[./-](\d{1,2})/);
    if (ymd) {
      const y = ymd[1],
        m = String(ymd[2]).padStart(2, "0"),
        d = String(ymd[3]).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
    const monthMap = {
      JAN: "01",
      FEB: "02",
      MAR: "03",
      APR: "04",
      MAY: "05",
      JUN: "06",
      JUL: "07",
      AUG: "08",
      SEP: "09",
      OCT: "10",
      NOV: "11",
      DEC: "12",
    };
    const dmy = raw.match(/^(\d{1,2})\s+([A-Za-z]{3})\s+(\d{4})$/);
    if (dmy) {
      const d = String(dmy[1]).padStart(2, "0");
      const mm = monthMap[dmy[2].toUpperCase()];
      const y = dmy[3];
      if (mm) return `${y}-${mm}-${d}`;
    }

    return "";
  };

  // LIST OF DATE FIELDS USED IN YOUR FORM (MUST MATCH BACKEND KEYS)
  const dateFields = [
    "date_of_birth",
    "expected_date_of_arrival",
    "passport_date_of_issue",
    "passport_date_of_expiry",
    "other_passport_doi",
    "last_visa_doi",
  ];

  // CREATE CLEAN VIEW DATA (NEVER MODIFY info)
  const viewInfo = (() => {
    const obj = { ...info };
    for (const key of dateFields) {
      if (obj[key]) obj[key] = normalizeDateValue(obj[key]);
    }
    return obj; 
  })();

  // (Your groups — unchanged)
  const groups = {
    basic_info: {
      label: "Basic Information",
      fields: [
        "passport_type",
        "nationality",
        "port_of_arrival",
        "date_of_birth",
        // "email_id",
        "expected_date_of_arrival",
      ],
    },
    personal_details: {
      label: "Personal Details",
      fields: [
        "surname",
        "given_name",
        "name_changed",
        "gender",
        "town_city_of_birth",
        "country_of_birth",
        "citizenship_national_id",
        "religion",
        "visible_identification_marks",
        "educational_qualification",
        "acquired_qualification",
        "nationality_acquisition",
        "prev_nationality",
        "lived_2_years",
        "father_name",
        "father_nationality",
        "father_prev_nationality",
        "father_pob",
        "father_cob",
        "mother_name",
        "mother_nationality",
        "mother_prev_nationality",
        "mother_pob",
        "mother_cob",
        "marital_status",
        "spouse_name",
        "spouse_nationality",
        "spouse_pob",
        "spouse_cob",
      ],
    },
    occupation_info: {
      label: "Occupation Details of Applicant",
      fields: [
        "occupation",
        "employer_name",
        "designation",
        "employer_address",
        // "employer_phone",

      ],
    },
    company_info: {
      label: "Details of Applicants Company",
      fields: [
        "applicant_company_name",
        "applicant_company_website",
        "applicant_company_address_phone",
        "nature_of_business_product",
      ],
    },

    passport_info: {
      label: "Passport Information",
      fields: [
        "passport_number",
        "passport_place_of_issue",
        "passport_date_of_issue",
        "passport_date_of_expiry",
        "other_passport",
        "other_passport_country",
        "other_passport_no",
        "other_passport_doi",
        "other_passport_poi",
        "other_passport_nationality",
      ],
    },
    present_address: {
      label: "Present Address",
      fields: [
        "present_address_street",
        "present_address_city",
        "present_address_state",
        "present_address_zip",
        "present_address_country",
        "present_phone",
      ],
    },
    permanent_address: {
      label: "Permanent Address",
      fields: [
        "same_address_checkbox",
        "permanent_street",
        "permanent_city",
        "permanent_state",
      ],
    },
    heritage_background: {
      label: "Heritage & Background",
      fields: ["pak_heritage", "pak_heritage_details"],
    },
    military_organization: {
      label: "Military Service",
      fields: ["military_designation", "military_organization", "military_posting", "military_rank"],
    },
    hotel_details: {
      label: "Hotel Details",
      fields: ["hotel_resort_name", "hotel_resort_city"],
    },
    visa_details: {
      label: "Visa Details",
      fields: ["places_to_visit", "exit_port"],
    },
    previous_india_visit: {
      label: "Previous India Visit",
      fields: [
        "visited_india_before",
        "prev_stay_address",
        "cities_visited",
        "last_visa_no",
        "last_visa_type",
        "last_visa_poi",
        "last_visa_doi",
        "permission_refused",
        "refusal_details",
        "countries_visited_10_years",
      ],
    },
    saarc_info: {
      label: "SAARC Visit Information",
      fields: ["saarc_visit", "saarc_country", "saarc_year", "saarc_visits"],
    },
    references: {
      label: "References",
      fields: [
        "reference_india_name",
        "reference_india_address",
        "reference_india_phone",
        "reference_home_name",
        "reference_home_address",
        "reference_home_phone",
      ],
    },
  };

  // TRIGGER LABEL
  const renderTriggerLabel = (groupKey) => {
    const group = groups[groupKey];
    const total = group.fields.length;
    const filled = countFilled(group.fields);
    return (
      <div className="flex items-center justify-between w-full">
        <span>{group.label}</span>
        <span className="ml-3 inline-flex items-center rounded-full border border-purple-200 bg-purple-50 px-2.5 py-0.5 text-xs font-medium text-purple-700">
          {filled}/{total} filled
        </span>
      </div>
    );
  };

  // FIELD RENDERER — ONLY DATE FIELD CHANGED
  // const renderField = (label, field, type = "text", required = false, options = null) => {
  //   const value = viewInfo[field];

  //   return (
  //     <div className="space-y-1">
  //       {type !== "checkbox" && (
  //         <Label className="text-sm font-medium text-gray-700">
  //           {label}
  //           {required && <span className="ml-0.5 text-red-500">*</span>}
  //         </Label>
  //       )}

  //       {options ? (
  //         <Select value={value ?? ""} onValueChange={(val) => updateField(field, val)}>
  //           <SelectTrigger className="relative z-[10]">
  //             <SelectValue placeholder={`Select ${label.toLowerCase()}`} />
  //           </SelectTrigger>
  //           <SelectContent position="popper" className="z-[99999]" sideOffset={4}>
  //             {options.map((opt) => (
  //               <SelectItem key={opt} value={opt}>{opt}</SelectItem>
  //             ))}
  //           </SelectContent>
  //         </Select>
  //       ) : type === "textarea" ? (
  //         <Textarea value={value || ""} onChange={(e) => updateField(field, e.target.value)} rows={3} />
  //       ) : type === "checkbox" ? (
  //         <div className="flex items-center gap-2 mt-1 cursor-pointer" onClick={() => updateField(field, !value)}>
  //           <Checkbox checked={Boolean(value)} />
  //           <Label className="text-sm text-gray-700 cursor-pointer">{label}</Label>
  //         </div>
  //       ) : type === "date" ? (
  //         <Input
  //           type="date"
  //           value={value || ""}
  //           onChange={(e) => updateField(field, e.target.value)}
  //         />
  //       ) : (
  //         <Input
  //           type={type}
  //           value={value || ""}
  //           onChange={(e) => updateField(field, e.target.value)}
  //         />
  //       )}
  //     </div>
  //   );
  // };

  // Helper functions for date validations
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Get date 5 working days from today (excluding Sundays only)
  const getMinArrivalDate = () => {
    let date = new Date();
    let workingDaysAdded = 0;

    // Count 5 working days forward (Monday-Saturday)
    while (workingDaysAdded < 5) {
      date.setDate(date.getDate() + 1);
      const dayOfWeek = date.getDay();
      // Skip only Sundays (0 = Sunday)
      if (dayOfWeek !== 0) {
        workingDaysAdded++;
      }
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Get date 6 months from today in YYYY-MM-DD format
  const getMinExpiryDate = () => {
    const today = new Date();
    today.setMonth(today.getMonth() + 6);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Check if a date violates the validation rules
  const getDateError = (field, value) => {
    if (!value) return null;

    const dateValue = new Date(value);
    const today = new Date(getTodayDate());
    const minExpiry = new Date(getMinExpiryDate());
    const minArrival = new Date(getMinArrivalDate());

    // Date of Birth: Cannot be in the future
    if (field === "date_of_birth") {
      if (dateValue > today) {
        return "Date of birth cannot be in the future";
      }
    }

    // Expected Arrival: Must be at least 5 working days from today
    if (field === "expected_date_of_arrival") {
      if (dateValue < minArrival) {
        return "Arrival date must be at least 5 working days from today";
      }
    }

    // Date of Issue: Cannot be in the future
    if (
      field === "passport_date_of_issue" ||
      field === "other_passport_doi" ||
      field.includes("date_of_issue")
    ) {
      if (dateValue > today) {
        return "Date of issue cannot be in the future";
      }
    }

    // Date of Expiry: Must be at least 6 months from today
    if (
      field === "passport_date_of_expiry" ||
      field.includes("date_of_expiry")
    ) {
      if (dateValue < minExpiry) {
        return "Passport must be valid for at least 6 months from today";
      }
    }

    return null;
  };

  //= renderField function with error messages
  const renderField = (
    label,
    field,
    type = "text",
    required = false,
    options = null
  ) => {
    const value = viewInfo[field];

    // Get validation error if date type
    const dateError = type === "date" ? getDateError(field, value) : null;

    // Determine date constraints based on field name
    let dateProps = {};
    if (type === "date") {
      // DOB: Cannot be in the future
      if (field === "date_of_birth") {
        dateProps.max = getTodayDate();
      }
      // Expected Arrival: Disable today + next 5 working days, enable dates after that
      else if (field === "expected_date_of_arrival") {
        dateProps.min = getMinArrivalDate();
      }
      // Passport/Other Passport Date of Issue: Cannot be future date
      else if (
        field === "passport_date_of_issue" ||
        field === "other_passport_doi" ||
        field.includes("date_of_issue")
      ) {
        dateProps.max = getTodayDate();
      }
      // Passport Date of Expiry: Must be at least 6 months from today
      else if (
        field === "passport_date_of_expiry" ||
        field.includes("date_of_expiry")
      ) {
        dateProps.min = getMinExpiryDate();
      }
    }

    return (
      <div className="space-y-1">
        {type !== "checkbox" && (
          <Label className="text-sm font-medium text-gray-700">
            {label}
            {required && <span className="ml-0.5 text-red-500">*</span>}
          </Label>
        )}

        {options ? (
          <Select
            value={value ?? ""}
            onValueChange={(val) => updateField(field, val)}
          >
            <SelectTrigger className="relative z-[10]">
              <SelectValue placeholder={`Select ${label.toLowerCase()}`} />
            </SelectTrigger>
            <SelectContent
              position="popper"
              className="z-[99999]"
              sideOffset={4}
            >
              {options.map((opt) => (
                <SelectItem key={opt} value={opt}>
                  {opt}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        ) : type === "textarea" ? (
          <Textarea
            value={value || ""}
            onChange={(e) => updateField(field, e.target.value)}
            rows={3}
          />
        ) : type === "checkbox" ? (
          <div
            className="flex items-center gap-2 mt-1 cursor-pointer"
            onClick={() => updateField(field, !value)}
          >
            <Checkbox checked={Boolean(value)} />
            <Label className="text-sm text-gray-700 cursor-pointer">
              {label}
            </Label>
          </div>
        ) : type === "date" ? (
          <>
            <Input
              type="date"
              value={value || ""}
              onChange={(e) => updateField(field, e.target.value)}
              className={dateError ? "border-red-500" : ""}
              {...dateProps} // Apply min/max constraints here
            />
            {dateError && (
              <p className="text-red-500 text-xs mt-1">{dateError}</p>
            )}
          </>
        ) : (
          <Input
            type={type}
            value={value || ""}
            onChange={(e) => updateField(field, e.target.value)}
          />
        )}
      </div>
    );
  };

  // RETURN JSX — UNCHANGED
  return (
    <div className="space-y-6">
      <Accordion type="multiple" defaultValue={[]}>
        {/* EVERYTHING BELOW IS EXACTLY THE SAME STRUCTURE */}
        {/* ---------------------------------------------------- */}

        {/* BASIC INFO */}
        <AccordionItem value="basic_info">
          <AccordionTrigger>
            {renderTriggerLabel("basic_info")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField("Passport Type", "passport_type", "text", false, [
                "Regular",
                "Official",
                "Diplomatic",
              ])}
              {renderField("Nationality", "nationality")}
              {renderField("Port of Arrival", "port_of_arrival")}
              {renderField("Date of Birth", "date_of_birth", "date")}
              {/* {renderField("Email ID", "email_id", "email")} */}
              {renderField(
                "Expected Date of Arrival",
                "expected_date_of_arrival",
                "date"
              )}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* PERSONAL DETAILS */}
        {/* <AccordionItem value="personal_details">
          <AccordionTrigger>
            {renderTriggerLabel("personal_details")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField("Surname", "surname")}
              {renderField("Given Name", "given_name")}
              {renderField("Gender", "gender", "text", false, [
                "Male",
                "Female",
                "Other",
              ])}
              {renderField("Town/City of Birth", "town_city_of_birth")}
              {renderField("Country of Birth", "country_of_birth")}
              {renderField(
                "Citizenship/National ID",
                "citizenship_national_id"
              )}
              {renderField("Religion", "religion")}
              {renderField(
                "Visible Identification Marks",
                "identity_marks"
              )}
              {renderField(
                "Educational Qualification",
                "educational_qualification"
              )}
               {renderField(
                "Acquired Qualification",
                "acquired_qualification"
              )}
              {renderField(
                "Nationality Acquisition",
                "nationality_acquisition",
                "text",
                false,
                ["By Birth", "By Naturalization"]
              )}
              {renderField(
                "Previous Nationality",
                "prev_nationality",
                "text",
              )}

              {renderField(
                "Name Changed",
                "name_changed",
                "text",
                false,
                ["Yes", "No"]
              )}

              {renderField(
                "Previous Surname",
                "previous_surname",
                "text",
              )}

              {renderField(
                "Previous Given Name",
                "previous_given_name",
                "text",
              )}

              {renderField(
                "Lived 2 Years in Current Country",
                "lived_2_years",
                "text",
                false,
                ["Yes", "No"]
              )}

              <div className="md:col-span-2 pt-4 border-t">
                <h5 className="font-medium text-gray-700 mb-2">
                  Family Information
                </h5>
              </div>

              {renderField("Father Name", "father_name")}
              {renderField("Mother Name", "mother_name")}
              {renderField("Father Nationality", "father_nationality")}
              {renderField("Mother Nationality", "mother_nationality")}
              {renderField(
                "Father Previous Nationality",
                "father_prev_nationality"
              )}
              {renderField(
                "Mother Previous Nationality",
                "mother_prev_nationality"
              )}
              {renderField("Father Place of Birth", "father_pob")}
              {renderField("Mother Place of Birth", "mother_pob")}
              {renderField("Father Country of Birth", "father_cob")}
              {renderField("Mother Country of Birth", "mother_cob")}

              {renderField("Marital Status", "marital_status", "text", false, [
                "Single",
                "Married",
                "Divorced",
                "Widowed",
              ])}

              {renderField("Spouse Name", "spouse_name")}
              {renderField("Spouse Nationality", "spouse_nationality")}
              {renderField("Spouse Place of Birth", "spouse_birth_place")}
              {renderField("Spouse Country of Birth", "spouse_birth_country")}
            </div>
          </AccordionContent>
        </AccordionItem> */}

        {/* PERSONAL DETAILS */}
        <AccordionItem value="personal_details">
          <AccordionTrigger>
            {renderTriggerLabel("personal_details")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Row 1: Surname and Given Name */}
              {renderField("Surname", "surname")}
              {renderField("Given Name", "given_name")}

              {/* Row 2: Gender and Town/City of Birth */}
              {renderField("Gender", "gender", "text", false, [
                "Male",
                "Female",
                "Other",
              ])}
              {renderField("Town/City of Birth", "town_city_of_birth")}

              {/* Row 3: Country of Birth and Citizenship/National ID */}
              {renderField("Country of Birth", "country_of_birth")}
              {renderField("Citizenship/National ID", "citizenship_national_id")}

              {/* Row 4: Religion and Visible Identification Marks */}
              {renderField("Religion", "religion")}
              {renderField("Visible Identification Marks", "identity_marks")}

              {/* Row 5: Educational Qualification and Acquired Qualification */}
              {renderField("Educational Qualification", "educational_qualification")}
              {renderField("Acquired Qualification", "acquired_qualification")}

              {/* Row 6: Nationality Acquisition and Previous Nationality */}
              {renderField(
                "Nationality Acquisition",
                "nationality_acquisition",
                "text",
                false,
                ["By Birth", "By Naturalization"]
              )}
              {renderField("Previous Nationality", "prev_nationality")}

              {/* Row 7: Name Changed and Previous Surname */}
              {renderField(
                "Name Changed",
                "name_changed",
                "text",
                false,
                ["Yes", "No"]
              )}
              {renderField("Previous Surname", "previous_surname")}

              {/* Row 8: Previous Given Name and Lived 2 Years */}
              {renderField("Previous Given Name", "previous_given_name")}
              {renderField(
                "Lived 2 Years in Current Country",
                "lived_2_years",
                "text",
                false,
                ["Yes", "No"]
              )}

              {/* Father Information Section */}
              <div className="md:col-span-2 pt-4 border-t mt-2">
                <h5 className="font-medium text-gray-700 mb-3">
                  Father Information
                </h5>
              </div>

              {/* Father Fields */}
              {renderField("Father Name", "father_name")}
              {renderField("Father Nationality", "father_nationality")}
              {renderField("Father Previous Nationality", "father_prev_nationality")}
              {renderField("Father Place of Birth", "father_pob")}
              {renderField("Father Country of Birth", "father_cob")}
              <div className="md:col-span-1"></div> {/* Empty space for alignment */}

              {/* Mother Information Section */}
              <div className="md:col-span-2 pt-4 border-t mt-2">
                <h5 className="font-medium text-gray-700 mb-3">
                  Mother Information
                </h5>
              </div>

              {/* Mother Fields */}
              {renderField("Mother Name", "mother_name")}
              {renderField("Mother Nationality", "mother_nationality")}
              {renderField("Mother Previous Nationality", "mother_prev_nationality")}
              {renderField("Mother Place of Birth", "mother_pob")}
              {renderField("Mother Country of Birth", "mother_cob")}
              <div className="md:col-span-1"></div> {/* Empty space for alignment */}

              {/* Spouse Information Section */}
              <div className="md:col-span-2 pt-4 border-t mt-2">
                <h5 className="font-medium text-gray-700 mb-3">
                  Spouse Information
                </h5>
              </div>

              {/* Spouse Fields */}
              {renderField("Marital Status", "marital_status", "text", false, [
                "Single",
                "Married",
                "Divorced",
                "Widowed",
              ])}
              {renderField("Spouse Name", "spouse_name")}
              {renderField("Spouse Nationality", "spouse_nationality")}
              {renderField("Spouse Place of Birth", "spouse_birth_place")}
              {renderField("Spouse Country of Birth", "spouse_birth_country")}
              <div className="md:col-span-1"></div> {/* Empty space for alignment */}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* OCCUPATION INFO */}
        <AccordionItem value="occupation_info">
          <AccordionTrigger>{renderTriggerLabel("occupation_info")}</AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField("Occupation", "occupation")}
              {renderField("Employer Name", "employer_name")}
              {renderField("Designation", "designation")}
              {renderField("Employer Address", "employer_address")}
              {/* {renderField("Employer Phone", "employer_phone")} */}


            </div>
          </AccordionContent>
        </AccordionItem>

        {/* COMPANY INFO */}
        <AccordionItem value="company_info">
          <AccordionTrigger>{renderTriggerLabel("company_info")}</AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField("Applicant Company Name", "applicant_company_name")}
              {renderField("Company Website", "applicant_company_website")}
              {renderField("Company Address/Phone", "applicant_company_address_phone")}
              {renderField("Nature of Business/Product", "nature_of_business_product")}

            </div>
          </AccordionContent>
        </AccordionItem>

        {/* Passport INFO */}
        <AccordionItem value="passport_info">
          <AccordionTrigger>
            {renderTriggerLabel("passport_info")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField("Passport Number", "passport_number")}
              {renderField(
                "Passport Place of Issue",
                "passport_place_of_issue"
              )}
              {/* Date of Issue - cannot be future date (max = today) */}
              {renderField(
                "Passport Date of Issue",
                "passport_date_of_issue",
                "date"
              )}
              {/* Date of Expiry - must be at least 6 months from today (min = today + 6 months) */}
              {renderField(
                "Passport Date of Expiry",
                "passport_date_of_expiry",
                "date"
              )}
              {renderField(
                "Have Other Passport?",
                "other_passport",
                "text",
                false,
                ["Yes", "No"]
              )}
              {renderField("Other Passport Country", "other_passport_country")}
              {renderField("Other Passport No", "other_passport_no")}
              {/* Other Passport Date of Issue - cannot be future date (max = today) */}
              {renderField(
                "Other Passport Date of Issue",
                "other_passport_doi",
                "date"
              )}
              {renderField(
                "Other Passport Place of Issue",
                "other_passport_poi"
              )}
              {renderField(
                "Other Passport Nationality",
                "other_passport_nationality"
              )}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* PRESENT ADDRESS */}
        <AccordionItem value="present_address">
          <AccordionTrigger>
            {renderTriggerLabel("present_address")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField("Street Address", "present_address_street")}
              {renderField("City", "present_address_city")}
              {renderField("State/Province/District", "present_address_state")}
              {renderField("ZIP / Postal Code", "present_address_zip")}
              {renderField("Country", "present_address_country")}
              {renderField("Phone", "present_phone", "tel")}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* PERMANENT ADDRESS */}
        <AccordionItem value="permanent_address">
          <AccordionTrigger>
            {renderTriggerLabel("permanent_address")}
          </AccordionTrigger>
          <AccordionContent>
            {renderField(
              "Same as Present Address",
              "same_address_checkbox",
              "checkbox"
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              {renderField("Street Address", "permanent_street")}
              {renderField("City", "permanent_city")}
              {renderField("State/Province/District", "permanent_state")}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* HERITAGE */}
        <AccordionItem value="heritage_background">
          <AccordionTrigger>
            {renderTriggerLabel("heritage_background")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField(
                "Pakistani Heritage",
                "pak_heritage",
                "text",
                false,
                ["Yes", "No"]
              )}
              {renderField(
                "Pakistani Heritage Details",
                "pak_heritage_details",
                "textarea"
              )}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* MILITARY */}
        <AccordionItem value="military_organization">
          <AccordionTrigger>
            {renderTriggerLabel("military_organization")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField(
                "In Military Service?",
                "in_military_service",
                "text",
                false,
                ["Yes", "No"]
              )}
              {renderField("Military Designation", "military_designation")}
              {renderField("Military Organization", "military_organization")}
              {renderField("Military Posting", "military_posting")}
              {renderField("Military Rank", "military_rank")}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* Hotel Details */}
        <AccordionItem value="hotel_details">
          <AccordionTrigger>
            {renderTriggerLabel("hotel_details")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField(
                "Booked Hotel?",
                "booked_hotel",
                "text",
                false,
                ["Yes", "No"]
              )}
              {renderField("Hotel Resort Name", "hotel_resort_name")}
              {renderField("Hotel Resort City", "hotel_resort_city")}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* VISA DETAILS */}
        <AccordionItem value="visa_details">
          <AccordionTrigger>
            {renderTriggerLabel("visa_details")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField("Places to Visit", "places_to_visit", "textarea")}

              {renderField("Exit Port", "exit_port")}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* PREVIOUS INDIA VISIT */}
        <AccordionItem value="previous_india_visit">
          <AccordionTrigger>
            {renderTriggerLabel("previous_india_visit")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField(
                "Visited India Before?",
                "visited_india_before",
                "text",
                false,
                ["Yes", "No"]
              )}

              {viewInfo.visited_india_before === "Yes" && (
                <>
                  {renderField(
                    "Previous Stay Address",
                    "prev_stay_address",
                    "textarea"
                  )}
                  {renderField("Cities Visited", "cities_visited")}
                  {renderField("Last Visa Number", "last_visa_no")}
                  {renderField("Last Visa Type", "last_visa_type")}
                  {renderField("Last Visa Place of Issue", "last_visa_poi")}
                  {renderField(
                    "Last Visa Date of Issue",
                    "last_visa_doi",
                    "date"
                  )}
                  {renderField(
                    "Permission Refused Before?",
                    "permission_refused",
                    "text",
                    false,
                    ["Yes", "No"]
                  )}
                  {renderField(
                    "Refusal Details",
                    "refusal_details",
                    "textarea"
                  )}
                </>
              )}

              {renderField(
                "Countries Visited (Last 10 Years)",
                "countries_visited_10_years",
                "textarea"
              )}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* SAARC */}
        <AccordionItem value="saarc_info">
          <AccordionTrigger>
            {renderTriggerLabel("saarc_info")}
          </AccordionTrigger>
          <AccordionContent>
            <div className="space-y-4">
              <Select
                value={viewInfo.saarc_visit ?? ""}
                onValueChange={(val) => {
                  updateField("saarc_visit", val);
                  // Initialize with one empty visit when "Yes" is selected
                  if (val === "Yes" && (!viewInfo.saarc_visits || viewInfo.saarc_visits.length === 0)) {
                    updateField("saarc_visits", [{ country: "", year: "", number: "" }]);
                  }
                  // Clear visits when "No" is selected
                  if (val === "No") {
                    updateField("saarc_visits", []);
                  }
                }}
              >
                <SelectTrigger className="relative z-[10]">
                  <SelectValue placeholder="Select SAARC Visit?" />
                </SelectTrigger>
                <SelectContent
                  position="popper"
                  className="z-[99999]"
                  sideOffset={4}
                >
                  <SelectItem value="Yes">Yes</SelectItem>
                  <SelectItem value="No">No</SelectItem>
                </SelectContent>
              </Select>

              {viewInfo.saarc_visit === "Yes" && viewInfo.saarc_visits && viewInfo.saarc_visits.length > 0 && (
                <div className="space-y-4">
                  {viewInfo.saarc_visits.map((visit, index) => (
                    <div key={index} className="border rounded-lg p-4 relative">
                      <div className="absolute top-2 right-2 flex gap-2">
                        {index === viewInfo.saarc_visits.length - 1 && (
                          <button
                            type="button"
                            onClick={() => {
                              const newVisits = [...viewInfo.saarc_visits];
                              newVisits.push({ country: "", year: "", number: "" });
                              updateField("saarc_visits", newVisits);
                            }}
                            className="w-6 h-6 rounded-full bg-green-500 text-white flex items-center justify-center hover:bg-green-600"
                          >
                            +
                          </button>
                        )}
                        {viewInfo.saarc_visits.length > 1 && (
                          <button
                            type="button"
                            onClick={() => {
                              const newVisits = viewInfo.saarc_visits.filter((_, i) => i !== index);
                              updateField("saarc_visits", newVisits);
                            }}
                            className="w-6 h-6 rounded-full bg-red-500 text-white flex items-center justify-center hover:bg-red-600"
                          >
                            −
                          </button>
                        )}
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                        <div className="space-y-1">
                          <Label className="text-sm font-medium text-gray-700">
                            SAARC Country
                          </Label>
                          <Select
                            value={visit.country || ""}
                            onValueChange={(val) => {
                              const newVisits = [...viewInfo.saarc_visits];
                              newVisits[index].country = val;
                              updateField("saarc_visits", newVisits);
                            }}
                          >
                            <SelectTrigger className="relative z-[10]">
                              <SelectValue placeholder="Select country" />
                            </SelectTrigger>
                            <SelectContent
                              position="popper"
                              className="z-[99999]"
                              sideOffset={4}
                            >
                              <SelectItem value="AFG">AFGHANISTAN</SelectItem>
                              <SelectItem value="BGD">BANGLADESH</SelectItem>
                              <SelectItem value="BTN">BHUTAN</SelectItem>
                              <SelectItem value="MDV">MALDIVES</SelectItem>
                              <SelectItem value="NPL">NEPAL</SelectItem>
                              <SelectItem value="PAK">PAKISTAN</SelectItem>
                              <SelectItem value="LKA">SRI LANKA</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>

                        <div className="space-y-1">
                          <Label className="text-sm font-medium text-gray-700">
                            SAARC Year
                          </Label>
                          <Select
                            value={visit.year || ""}
                            onValueChange={(val) => {
                              const newVisits = [...viewInfo.saarc_visits];
                              newVisits[index].year = val;
                              updateField("saarc_visits", newVisits);
                            }}
                          >
                            <SelectTrigger className="relative z-[10]">
                              <SelectValue placeholder="Select year" />
                            </SelectTrigger>
                            <SelectContent
                              position="popper"
                              className="z-[99999]"
                              sideOffset={4}
                            >
                              {Array.from({ length: 4 }, (_, i) => {
                                const year = new Date().getFullYear() - i;
                                return (
                                  <SelectItem key={year} value={year.toString()}>
                                    {year}
                                  </SelectItem>
                                );
                              })}
                            </SelectContent>
                          </Select>
                        </div>

                        <div className="space-y-1">
                          <Label className="text-sm font-medium text-gray-700">
                            Number of Visits
                          </Label>
                          <Input
                            type="number"
                            value={visit.number || ""}
                            onChange={(e) => {
                              const newVisits = [...viewInfo.saarc_visits];
                              newVisits[index].number = e.target.value;
                              updateField("saarc_visits", newVisits);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </AccordionContent>
        </AccordionItem>

        {/* REFERENCES */}
        <AccordionItem value="references">
          <AccordionTrigger>
            {renderTriggerLabel("references")}
          </AccordionTrigger>
          <AccordionContent>
            <h5 className="font-medium mb-2">Reference in India</h5>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderField("Name", "reference_india_name")}
              {renderField("Address", "reference_india_address", "textarea")}
              {renderField("Phone", "reference_india_phone", "tel")}

              <div className="md:col-span-2 mt-4">
                <h5 className="font-medium mb-2">Reference in Home Country</h5>
              </div>

              {renderField("Name", "reference_home_name")}
              {renderField("Address", "reference_home_address", "textarea")}
              {renderField("Phone", "reference_home_phone", "tel")}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      {/* DECLARATION */}
      {/* <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
        {renderField("I declare that all information provided is true and correct", "declaration", "checkbox")}
      </div> */}
    </div>
  );
};

export default ComprehensiveFormV2;
